import { delay, fork, put, call, takeLatest } from 'redux-saga/effects';

import { SupportActions } from "../constants/support";
import { createShowErrorAction, createShowSuccessAction } from "../actions/notifications";
import apiSettings from '../config/apiSettings';
import { getAccessTokenEffect } from './helpers';
import * as supportActions from "../actions/support";

import api from '../server/support';

const getReportAction = supportActions.createGetReportAction();
const setReportAction = supportActions.createSetReportAction();
const showErrorAction = createShowErrorAction();
const showSuccessAction = createShowSuccessAction();
const setIsReportLoading = supportActions.createIsReportLoadingAction();
const setIsResyncUserLoading = supportActions.createIsResyncUserLoadingAction();

export function* getReportEffect(action) {
  try {
    yield put(setIsReportLoading(true));
    const accessToken = yield call(getAccessTokenEffect, apiSettings.scopes);
    const result = yield call(api.getReportUser, action.payload, accessToken);
    
    if (result) {
      yield delay(500);
      yield put(setReportAction(result.data));
    } else {
      yield put(showErrorAction('Get report failed'));
      yield put(setReportAction(null));
    }
    yield put(setIsReportLoading(false));
  } catch (e) {
    yield put(showErrorAction(`Get report failed, error "${e.message}"`));
    yield put(setIsReportLoading(false));
    yield put(setReportAction(null));
  }
}

function* dispatchGetReportEffect(payload) {
  yield put(getReportAction(payload));
}

export function* resyncUserEffect(action) {
  try {
    yield put(setIsResyncUserLoading(true));
    const accessToken = yield call(getAccessTokenEffect, apiSettings.scopes);
    const result = yield call(api.resyncUser, action.payload, accessToken);
    
    if (result) {
      yield put(showSuccessAction(`Resync user succeeded. For many activites please wait a moment and reload`));
      yield delay(2000);
      // yield fork(dispatchGetReportEffect, { UserId: action.payload.UserId });
    } else {
      yield put(showErrorAction('Resync user failed'));
    }
    yield put(setIsResyncUserLoading(false));
  } catch (e) {
    yield put(showErrorAction(`Resync user failed, error "${e.message}"`));
    yield put(setIsResyncUserLoading(false));
  }
}

export default [
    takeLatest(SupportActions.GetReport, getReportEffect),
    takeLatest(SupportActions.ResyncUser, resyncUserEffect),
];